import { UserRole } from '../../../api/users';
import { Button } from '../../../Components/Button/Button';

import { Icons } from '../../../Components/Icons/Icons';
import { useAuth } from '../../../contexts/AuthContext';
import { DatePicker } from '../../../Components/DatePicker/DatePicker';
import clsx from 'clsx';

interface EventsHeaderProps {
  onAddEvent: () => void;
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
}

export const EventsHeader = ({
  onAddEvent,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: EventsHeaderProps) => {
  const { userData } = useAuth();

  const handleClearFilters = () => {
    onStartDateChange(null);
    onEndDateChange(null);
  };

  const isAnyFilterActive = Boolean(startDate || endDate);

  return (
    <>
      <h1>
        Events
        <a
          className="btn outline"
          target="_blank"
          href="https://app.smartsheet.com/b/form/2a6e5672f2ab4db9993ad10ef2d0d9bb"
          rel="noreferrer"
        >
          Submit a Request
        </a>
      </h1>
      <div className="page-header">
        <div
          className={clsx('filter-group', {
            filtered: isAnyFilterActive,
          })}
        >
          <DatePicker
            id="start-date"
            name="startDate"
            label="Start Date"
            value={startDate}
            onChange={onStartDateChange}
          />
          <DatePicker
            id="end-date"
            name="endDate"
            label="End Date"
            value={endDate}
            onChange={onEndDateChange}
          />
          <div className="clear-filter" onClick={handleClearFilters}>
            {Icons.Close}
            Reset Filters
          </div>
        </div>
        {userData?.role === UserRole.ADMIN && (
          <div className="btns">
            <Button variant="button" onClick={onAddEvent}>
              {Icons.WhitePlus} Add New Event
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
